import { render, staticRenderFns } from "./AgendarInfusao.vue?vue&type=template&id=392e937e&"
import script from "./AgendarInfusao.vue?vue&type=script&lang=js&"
export * from "./AgendarInfusao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports